
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import BusinessList from '@/views/BusinessList.vue'
import GaodeMap from '@/views/Gaode/GaodeMap.vue'
import BaiduMap from '@/views/Baidu/BaiduMap.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/businessList',
    name: 'BusinessList',
    component: BusinessList,
    meta: { requiresAuth: true }
  },
  {
    path: '/gaode/gaodemap',
    name: 'GaodeMap',
    component: GaodeMap,
    meta: { requiresAuth: true }
  },
  {
    path: '/gaode/gaodemap/:lat/:lng/:busname',
    name: 'GaodeMap',
    component: GaodeMap,
    meta: { requiresAuth: true }
  },
  {
    path: '/baidu/baidumap/:lat/:lng/:busname',
    name: 'BaiduMap',
    component: BaiduMap,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
